<template>
  <TransferLogic is-verify />
</template>
<script>
import TransferLogic from '@/views/center-business/stock/transfer/virtual/index';
export default {
  name: 'BusinessStockVerifyVirtualIndex',
  components: {
    TransferLogic,
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
